import fonts from './fonts'

const textStyles = {
  titleH1: `
    ${fonts.BBCondBold}
    font-size: 30px;
    text-transform: uppercase;
    line-height: initial;
  `,
  titleH2: `
    ${fonts.UniversBoldCondensed}
    font-size: 24px;
    line-height: initial;
    text-transform: uppercase;
  `,
  titleH3: `
  ${fonts.UniversBoldCondensed}
  font-size: 18px;
  line-height: initial;
  text-transform: uppercase;
  `,
  WebTitleH1: `
    ${fonts.BBCondBold}
    font-size: 12px;
    text-transform: uppercase;
    line-height: initial;
  `,
  WebTitleH2: `
    ${fonts.UniversBoldCondensed}
    font-size: 14px;
    line-height: initial;
    text-transform: uppercase;
  `,
  WebTitleH3: `
  ${fonts.UniversBoldCondensed}
  font-size: 12px;
  line-height: initial;
  text-transform: uppercase;
  `,
  display: `
    ${fonts.BBCondBold}
    font-size: 22px;
    line-height: initial;
    text-transform: uppercase;
  `,
  body: `
    ${fonts.BBRegular}
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
  `,
  // bodyTiny: `
  //   ${fonts.UniversRoman}
  //   font-size: 14px;
  //   font-weight: 400;
  //   line-height: 1.5;
  // `,
  text: `
    ${fonts.UniversRoman}
    font-size: 14px;
    line-height: 1.5;
  `,
  textBold: `
    ${fonts.UniversBoldCondensed}
    font-size: 14px;
    font-weight: 700;
    line-height: 1.5;
  `,
  tiny: `
    ${fonts.UniversRoman}
    font-size: 12px;
    line-height: 150%;
    letter-spacing: 0.05em;
  `,
  // button: `
  //   ${fonts.BBCond}
  //   font-size: 12px;
  //   font-weight: 400;
  //   line-height: 1.5;
  //   text-transform: uppercase;
  // `,
}

export default textStyles
